const SignIn = {
  options: {
    data: {
      text: {
        type: 'Text',
        order: 1,
      },
      description: {
        type: 'Text',
        order: 1,
      },
      privacyPolicyLink: {
        type: 'Text',
        order: 1,
      },
    },
    customization: {
      textColor: {
        type: 'HexColor',
        order: 2,
      },
      textSize: {
        type: 'RangePx',
        data: {
          max: 30,
          min: 0,
          step: 1,
        },
        order: 2,
      },
      textWeight: {
        type: 'SelectBox',
        data: {
          selectOptions: ['100', '200', '300', '400', '500', '600', '700', '800', '900'],
        },
        order: 3,
      },
      textPadding: {
        type: 'FourPx',
        data: {
          max: 200,
          min: 0,
          step: 1,
          svgType: 'edge',
        },
        order: 4,
      },
      logoBackgroundColor: {
        type: 'HexColor',
        order: 5,
      },
      inputTextColor: {
        type: 'HexColor',
        order: 6,
      },
      inputBackgroundColor: {
        type: 'HexColor',
        order: 7,
      },
      emailIcon: {
        type: 'IconSelector',
        data: {
          defaultIcon:
            'https://d9aff4nz0lkg0.cloudfront.net/icon/png/1710504660_a167aca9-0425-4762-965e-0d6f8c6d24ef.png',
        },
        order: 8,
      },
      passwordIcon: {
        type: 'IconSelector',
        data: {
          defaultIcon:
            'https://d9aff4nz0lkg0.cloudfront.net/icon/png/1710504283_aa8f943e-e7bc-45f1-a7ad-4c77b1f6aa9d.png',
        },
        order: 8,
      },
      passwordOpenIcon: {
        type: 'IconSelector',
        data: {
          defaultIcon:
            'https://d9aff4nz0lkg0.cloudfront.net/icon/png/1710504266_efd51b93-7875-4bc5-aee7-24fecc33b79e.png',
        },
        order: 8,
      },
      passwordCloseIcon: {
        type: 'IconSelector',
        data: {
          defaultIcon:
            'https://d9aff4nz0lkg0.cloudfront.net/icon/png/1710504284_93059095-3c2a-4087-b4ae-163e8149656e.png',
        },
        order: 8,
      },
      logo: {
        type: 'ImageUploader',
      },
      textAlignment: {
        type: 'LeftCenterRight',
        order: 4,
      },
      buttonColor: {
        type: 'HexColor',
        order: 7,
      },
      buttonTextColor: {
        type: 'HexColor',
        order: 7,
      },
      accentColor: {
        type: 'HexColor',
        order: 7,
      },
    },
  },
  variants: [
    {
      id: 'SignIn_1',
      name: 'SignIn_1',
      type: 'SignIn',
      data: {
        text: 'Giriş Yap',
        privacyPolicyLink: '',
        images: [],
      },
      customization: {
        textColor: '#000000',
        textSize: '20px',
        textPadding: '10px 10px 10px 10px',
        textWeight: '700',
        emailIcon: 'https://d9aff4nz0lkg0.cloudfront.net/seyf/mail.png',
        passwordIcon: 'https://d9aff4nz0lkg0.cloudfront.net/seyf/locked-computer.png',
        passwordOpenIcon:
          'https://d9aff4nz0lkg0.cloudfront.net/icon/png/1710504266_efd51b93-7875-4bc5-aee7-24fecc33b79e.png',
        passwordCloseIcon:
          'https://d9aff4nz0lkg0.cloudfront.net/icon/png/1710504284_93059095-3c2a-4087-b4ae-163e8149656e.png',
        buttonColor: '#6F59EF',
        buttonTextColor: '#FFFFFF',
        accentColor: '#7059ef',
      },
      variantData: {
        isEditable: false,
        aspectRatio: '1/1',
        minImage: 4,
        maxImage: 12,
        modulo: 1,
        renderTabs: {
          product: null,
        },
      },
      placeholderImage: 'https://d9aff4nz0lkg0.cloudfront.net/signin.png',
      minMobileAppVersion: 1,
      isComingSoon: false,
    },
    {
      id: 'SignIn_2',
      name: 'SignIn_2',
      type: 'SignIn',
      data: {
        text: '',
        description: '',
        privacyPolicyLink: '',
        images: [],
      },
      customization: {
        textColor: '#000000',
        textSize: '20px',
        textWeight: '700',
        emailIcon: 'https://d9aff4nz0lkg0.cloudfront.net/seyf/mail.png',
        passwordIcon: 'https://d9aff4nz0lkg0.cloudfront.net/seyf/locked-computer.png',
        passwordOpenIcon:
          'https://d9aff4nz0lkg0.cloudfront.net/icon/png/1710504266_efd51b93-7875-4bc5-aee7-24fecc33b79e.png',
        passwordCloseIcon:
          'https://d9aff4nz0lkg0.cloudfront.net/icon/png/1710504284_93059095-3c2a-4087-b4ae-163e8149656e.png',
        textAlignment: 'center',
        buttonColor: '#6F59EF',
        buttonTextColor: '#FFFFFF',
        accentColor: '#7059ef',
      },
      variantData: {
        isEditable: false,
        aspectRatio: '1/1',
        minImage: 4,
        maxImage: 12,
        modulo: 1,
        renderTabs: {
          product: null,
        },
      },
      placeholderImage: 'https://d9aff4nz0lkg0.cloudfront.net/login_2.png',
      minMobileAppVersion: 1,
      isComingSoon: false,
    },
    {
      id: 'SignIn_3',
      name: 'SignIn_3',
      type: 'SignIn',
      data: {
        text: '',
        description: '',
        privacyPolicyLink: '',
        images: [],
      },
      customization: {
        textColor: '#000000',
        textSize: '20px',
        textWeight: '700',
        passwordOpenIcon:
          'https://d9aff4nz0lkg0.cloudfront.net/icon/png/1710504266_efd51b93-7875-4bc5-aee7-24fecc33b79e.png',
        passwordCloseIcon:
          'https://d9aff4nz0lkg0.cloudfront.net/icon/png/1710504284_93059095-3c2a-4087-b4ae-163e8149656e.png',
        textAlignment: 'left',
        logo: 'https://d9aff4nz0lkg0.cloudfront.net/mobligo/mobligo_new.f1a0e145b0fcc9ce50bd.png',
        buttonColor: '#6F59EF',
        buttonTextColor: '#FFFFFF',
        accentColor: '#7059ef',
      },
      variantData: {
        isEditable: false,
        aspectRatio: '1/1',
        minImage: 4,
        maxImage: 12,
        modulo: 1,
        renderTabs: {
          product: null,
        },
      },
      placeholderImage: 'https://d9aff4nz0lkg0.cloudfront.net/login_3.png',
      minMobileAppVersion: 1,
      isComingSoon: false,
    },
    {
      id: 'SignIn_4',
      name: 'SignIn_4',
      type: 'SignIn',
      data: {
        text: '',
        description: '',
        privacyPolicyLink: '',
        images: [],
      },
      customization: {
        textColor: '#000000',
        textSize: '20px',
        textWeight: '700',
        emailIcon: 'https://d9aff4nz0lkg0.cloudfront.net/seyf/mail.png',
        passwordIcon: 'https://d9aff4nz0lkg0.cloudfront.net/seyf/locked-computer.png',
        passwordOpenIcon:
          'https://d9aff4nz0lkg0.cloudfront.net/icon/png/1710504266_efd51b93-7875-4bc5-aee7-24fecc33b79e.png',
        passwordCloseIcon:
          'https://d9aff4nz0lkg0.cloudfront.net/icon/png/1710504284_93059095-3c2a-4087-b4ae-163e8149656e.png',
        textAlignment: 'left',
        logo: 'https://d9aff4nz0lkg0.cloudfront.net/mobligo/mobligo_new.f1a0e145b0fcc9ce50bd.png',
        buttonColor: '#6F59EF',
        buttonTextColor: '#FFFFFF',
        accentColor: '#7059ef',
      },
      variantData: {
        isEditable: false,
        aspectRatio: '1/1',
        minImage: 4,
        maxImage: 12,
        modulo: 1,
        renderTabs: {
          product: null,
        },
      },
      placeholderImage: 'https://d9aff4nz0lkg0.cloudfront.net/login_9.png',
      minMobileAppVersion: 1,
      isComingSoon: true,
    },
    {
      id: 'SignIn_5',
      name: 'SignIn_5',
      type: 'SignIn',
      data: {
        text: '',
        description: '',
        privacyPolicyLink: '',
        images: [],
      },
      customization: {
        textColor: '#000000',
        textSize: '20px',
        textWeight: '700',
        passwordOpenIcon:
          'https://d9aff4nz0lkg0.cloudfront.net/icon/png/1710504266_efd51b93-7875-4bc5-aee7-24fecc33b79e.png',
        passwordCloseIcon:
          'https://d9aff4nz0lkg0.cloudfront.net/icon/png/1710504284_93059095-3c2a-4087-b4ae-163e8149656e.png',
        textAlignment: 'center',
        logo: 'https://d9aff4nz0lkg0.cloudfront.net/mobligo/mobligo_new.f1a0e145b0fcc9ce50bd.png',
        buttonColor: '#6F59EF',
        buttonTextColor: '#FFFFFF',
        accentColor: '#7059ef',
      },
      variantData: {
        isEditable: false,
        aspectRatio: '1/1',
        minImage: 4,
        maxImage: 12,
        modulo: 1,
        renderTabs: {
          product: null,
        },
      },
      placeholderImage: 'https://d9aff4nz0lkg0.cloudfront.net/login_5.png',
      minMobileAppVersion: 1,
      isComingSoon: true,
    },
    {
      id: 'SignIn_6',
      name: 'SignIn_6',
      type: 'SignIn',
      data: {
        text: '',
        description: '',
        privacyPolicyLink: '',
        images: [],
      },
      customization: {
        textColor: '#000000',
        textSize: '20px',
        textWeight: '700',
        passwordOpenIcon:
          'https://d9aff4nz0lkg0.cloudfront.net/icon/png/1710504266_efd51b93-7875-4bc5-aee7-24fecc33b79e.png',
        passwordCloseIcon:
          'https://d9aff4nz0lkg0.cloudfront.net/icon/png/1710504284_93059095-3c2a-4087-b4ae-163e8149656e.png',
        textAlignment: 'center',
        logo: 'https://d9aff4nz0lkg0.cloudfront.net/mobligo/mobligo_new.f1a0e145b0fcc9ce50bd.png',
        buttonColor: '#6F59EF',
        buttonTextColor: '#FFFFFF',
        accentColor: '#7059ef',
        logoBackgroundColor: '#F0EEFC',
      },
      variantData: {
        isEditable: false,
        aspectRatio: '1/1',
        minImage: 4,
        maxImage: 12,
        modulo: 1,
        renderTabs: {
          product: null,
        },
      },
      placeholderImage: 'https://d9aff4nz0lkg0.cloudfront.net/login_6.png',
      minMobileAppVersion: 1,
      isComingSoon: false,
    },
    {
      id: 'SignIn_7',
      name: 'SignIn_7',
      type: 'SignIn',
      data: {
        text: '',
        description: '',
        privacyPolicyLink: '',
        images: [],
      },
      customization: {
        textColor: '#000000',
        textSize: '20px',
        textWeight: '700',
        passwordOpenIcon:
          'https://d9aff4nz0lkg0.cloudfront.net/icon/png/1710504266_efd51b93-7875-4bc5-aee7-24fecc33b79e.png',
        passwordCloseIcon:
          'https://d9aff4nz0lkg0.cloudfront.net/icon/png/1710504284_93059095-3c2a-4087-b4ae-163e8149656e.png',
        textAlignment: 'left',
        logo: 'https://d9aff4nz0lkg0.cloudfront.net/mobligo/mobligo_new.f1a0e145b0fcc9ce50bd.png',
        buttonColor: '#6F59EF',
        buttonTextColor: '#FFFFFF',
        accentColor: '#7059ef',
      },
      variantData: {
        isEditable: false,
        aspectRatio: '1/1',
        minImage: 4,
        maxImage: 12,
        modulo: 1,
        renderTabs: {
          product: null,
        },
      },
      placeholderImage: 'https://d9aff4nz0lkg0.cloudfront.net/login_10.png',
      minMobileAppVersion: 1,
      isComingSoon: true,
    },
    {
      id: 'SignIn_8',
      name: 'SignIn_8',
      type: 'SignIn',
      data: {
        text: '',
        description: '',
        privacyPolicyLink: '',
        images: [],
      },
      customization: {
        textColor: '#000000',
        textSize: '20px',
        textWeight: '700',
        emailIcon: 'https://d9aff4nz0lkg0.cloudfront.net/seyf/mail.png',
        passwordIcon: 'https://d9aff4nz0lkg0.cloudfront.net/seyf/locked-computer.png',
        passwordOpenIcon:
          'https://d9aff4nz0lkg0.cloudfront.net/icon/png/1710504266_efd51b93-7875-4bc5-aee7-24fecc33b79e.png',
        passwordCloseIcon:
          'https://d9aff4nz0lkg0.cloudfront.net/icon/png/1710504284_93059095-3c2a-4087-b4ae-163e8149656e.png',
        textAlignment: 'center',
        buttonColor: '#6F59EF',
        buttonTextColor: '#FFFFFF',
        accentColor: '#7059ef',
      },
      variantData: {
        isEditable: false,
        aspectRatio: '1/1',
        minImage: 4,
        maxImage: 12,
        modulo: 1,
        renderTabs: {
          product: null,
        },
      },
      placeholderImage: 'https://d9aff4nz0lkg0.cloudfront.net/login_8.png',
      minMobileAppVersion: 1,
      isComingSoon: true,
    },
    {
      id: 'SignIn_9',
      name: 'SignIn_9',
      type: 'SignIn',
      data: {
        text: '',
        description: '',
        privacyPolicyLink: '',
        images: [],
      },
      customization: {
        textColor: '#000000',
        textSize: '20px',
        textWeight: '700',
        emailIcon: 'https://d9aff4nz0lkg0.cloudfront.net/seyf/mail.png',
        passwordIcon: 'https://d9aff4nz0lkg0.cloudfront.net/seyf/locked-computer.png',
        passwordOpenIcon:
          'https://d9aff4nz0lkg0.cloudfront.net/icon/png/1710504266_efd51b93-7875-4bc5-aee7-24fecc33b79e.png',
        passwordCloseIcon:
          'https://d9aff4nz0lkg0.cloudfront.net/icon/png/1710504284_93059095-3c2a-4087-b4ae-163e8149656e.png',
        textAlignment: 'left',
        logo: 'https://d9aff4nz0lkg0.cloudfront.net/mobligo/mobligo_new.f1a0e145b0fcc9ce50bd.png',
        buttonColor: '#6F59EF',
        buttonTextColor: '#FFFFFF',
        accentColor: '#7059ef',
      },
      variantData: {
        isEditable: false,
        aspectRatio: '1/1',
        minImage: 4,
        maxImage: 12,
        modulo: 1,
        renderTabs: {
          product: null,
        },
      },
      placeholderImage: 'https://d9aff4nz0lkg0.cloudfront.net/login_4.png',
      minMobileAppVersion: 1,
      isComingSoon: false,
    },
    {
      id: 'SignIn_10',
      name: 'SignIn_10',
      type: 'SignIn',
      data: {
        text: '',
        description: '',
        privacyPolicyLink: '',
        images: [],
      },
      customization: {
        textColor: '#000000',
        textSize: '20px',
        textWeight: '700',
        passwordOpenIcon:
          'https://d9aff4nz0lkg0.cloudfront.net/icon/png/1710504266_efd51b93-7875-4bc5-aee7-24fecc33b79e.png',
        passwordCloseIcon:
          'https://d9aff4nz0lkg0.cloudfront.net/icon/png/1710504284_93059095-3c2a-4087-b4ae-163e8149656e.png',
        logo: 'https://d9aff4nz0lkg0.cloudfront.net/Product+Grid+17.pngmobligo/mobligo_new.f1a0e145b0fcc9ce50bd.png',
        buttonColor: '#6F59EF',
        buttonTextColor: '#FFFFFF',
        accentColor: '#7059ef',
      },
      variantData: {
        isEditable: false,
        aspectRatio: '1/1',
        minImage: 4,
        maxImage: 12,
        modulo: 1,
        renderTabs: {
          product: null,
        },
      },
      placeholderImage: 'https://d9aff4nz0lkg0.cloudfront.net/login_7.png',
      minMobileAppVersion: 1,
      isComingSoon: false,
    },
    {
      id: 'SignIn_11',
      name: 'SignIn_11',
      type: 'SignIn',
      data: {
        text: '',
        description: '',
        privacyPolicyLink: '',
        images: [],
      },
      customization: {
        textColor: '#000000',
        textSize: '20px',
        textWeight: '700',
        passwordOpenIcon:
          'https://d9aff4nz0lkg0.cloudfront.net/icon/png/1710504266_efd51b93-7875-4bc5-aee7-24fecc33b79e.png',
        passwordCloseIcon:
          'https://d9aff4nz0lkg0.cloudfront.net/icon/png/1710504284_93059095-3c2a-4087-b4ae-163e8149656e.png',
        textAlignment: 'left',
        buttonColor: '#6F59EF',
        buttonTextColor: '#FFFFFF',
        accentColor: '#7059ef',
      },
      variantData: {
        isEditable: false,
        aspectRatio: '1/1',
        minImage: 4,
        maxImage: 12,
        modulo: 1,
        renderTabs: {
          product: null,
        },
      },
      placeholderImage: 'https://d9aff4nz0lkg0.cloudfront.net/login_11.png',
      minMobileAppVersion: 1,
      isComingSoon: true,
    },
    {
      id: 'SignIn_12',
      name: 'SignIn_12',
      type: 'SignIn',
      data: {
        text: '',
        description: '',
        privacyPolicyLink: '',
        images: [],
      },
      customization: {
        textColor: '#000000',
        textSize: '20px',
        textWeight: '700',
        passwordOpenIcon:
          'https://d9aff4nz0lkg0.cloudfront.net/icon/png/1710504266_efd51b93-7875-4bc5-aee7-24fecc33b79e.png',
        passwordCloseIcon:
          'https://d9aff4nz0lkg0.cloudfront.net/icon/png/1710504284_93059095-3c2a-4087-b4ae-163e8149656e.png',
        textAlignment: 'left',
        logo: 'https://d9aff4nz0lkg0.cloudfront.net/mobligo/mobligo_new.f1a0e145b0fcc9ce50bd.png',
        buttonColor: '#6F59EF',
        buttonTextColor: '#FFFFFF',
        accentColor: '#7059ef',
      },
      variantData: {
        isEditable: false,
        aspectRatio: '1/1',
        minImage: 4,
        maxImage: 12,
        modulo: 1,
        renderTabs: {
          product: null,
        },
      },
      placeholderImage: 'https://d9aff4nz0lkg0.cloudfront.net/login_12.png',
      minMobileAppVersion: 1,
      isComingSoon: true,
    },
    {
      id: 'SignIn_13',
      name: 'SignIn_13',
      type: 'SignIn',
      data: {
        text: '',
        description: '',
        privacyPolicyLink: '',
        images: [],
      },
      customization: {
        textColor: '#000000',
        textSize: '20px',
        textWeight: '700',
        emailIcon: 'https://d9aff4nz0lkg0.cloudfront.net/seyf/mail.png',
        passwordIcon: 'https://d9aff4nz0lkg0.cloudfront.net/seyf/locked-computer.png',
        passwordOpenIcon:
          'https://d9aff4nz0lkg0.cloudfront.net/icon/png/1710504266_efd51b93-7875-4bc5-aee7-24fecc33b79e.png',
        passwordCloseIcon:
          'https://d9aff4nz0lkg0.cloudfront.net/icon/png/1710504284_93059095-3c2a-4087-b4ae-163e8149656e.png',
        textAlignment: 'center',
        logo: 'https://d9aff4nz0lkg0.cloudfront.net/mobligo/mobligo_new.f1a0e145b0fcc9ce50bd.png',
        buttonColor: '#6F59EF',
        buttonTextColor: '#FFFFFF',
        accentColor: '#7059ef',
      },
      variantData: {
        isEditable: false,
        aspectRatio: '1/1',
        minImage: 4,
        maxImage: 12,
        modulo: 1,
        renderTabs: {
          product: null,
        },
      },
      placeholderImage: 'https://d9aff4nz0lkg0.cloudfront.net/login_13.png',
      minMobileAppVersion: 1,
      isComingSoon: true,
    },
    {
      id: 'SignIn_14',
      name: 'SignIn_14',
      type: 'SignIn',
      data: {
        text: '',
        description: '',
        privacyPolicyLink: '',
        images: [],
      },
      customization: {
        textColor: '#000000',
        textSize: '20px',
        textWeight: '700',
        passwordOpenIcon:
          'https://d9aff4nz0lkg0.cloudfront.net/icon/png/1710504266_efd51b93-7875-4bc5-aee7-24fecc33b79e.png',
        passwordCloseIcon:
          'https://d9aff4nz0lkg0.cloudfront.net/icon/png/1710504284_93059095-3c2a-4087-b4ae-163e8149656e.png',
        textAlignment: 'left',
        buttonColor: '#6F59EF',
        buttonTextColor: '#FFFFFF',
        accentColor: '#7059ef',
      },
      variantData: {
        isEditable: false,
        aspectRatio: '1/1',
        minImage: 4,
        maxImage: 12,
        modulo: 1,
        renderTabs: {
          product: null,
        },
      },
      placeholderImage: 'https://d9aff4nz0lkg0.cloudfront.net/login_14.png',
      minMobileAppVersion: 1,
      isComingSoon: true,
    },
    {
      id: 'SignIn_15',
      name: 'SignIn_15',
      type: 'SignIn',
      data: {
        text: '',
        description: '',
        privacyPolicyLink: '',
        images: [],
      },
      customization: {
        textColor: '#000000',
        textSize: '20px',
        textWeight: '700',
        passwordOpenIcon:
          'https://d9aff4nz0lkg0.cloudfront.net/icon/png/1710504266_efd51b93-7875-4bc5-aee7-24fecc33b79e.png',
        passwordCloseIcon:
          'https://d9aff4nz0lkg0.cloudfront.net/icon/png/1710504284_93059095-3c2a-4087-b4ae-163e8149656e.png',
        textAlignment: 'left',
        buttonColor: '#6F59EF',
        buttonTextColor: '#FFFFFF',
        accentColor: '#7059ef',
      },
      variantData: {
        isEditable: false,
        aspectRatio: '1/1',
        minImage: 4,
        maxImage: 12,
        modulo: 1,
        renderTabs: {
          product: null,
        },
      },
      placeholderImage: 'https://d9aff4nz0lkg0.cloudfront.net/login_15.png',
      minMobileAppVersion: 1,
      isComingSoon: true,
    },
    {
      id: 'SignIn_16',
      name: 'SignIn_16',
      type: 'SignIn',
      data: {
        text: '',
        description: '',
        privacyPolicyLink: '',
        images: [],
      },
      customization: {
        textColor: '#000000',
        textSize: '20px',
        textWeight: '700',
        emailIcon: 'https://d9aff4nz0lkg0.cloudfront.net/seyf/mail.png',
        passwordIcon: 'https://d9aff4nz0lkg0.cloudfront.net/seyf/locked-computer.png',
        passwordOpenIcon:
          'https://d9aff4nz0lkg0.cloudfront.net/icon/png/1710504266_efd51b93-7875-4bc5-aee7-24fecc33b79e.png',
        passwordCloseIcon:
          'https://d9aff4nz0lkg0.cloudfront.net/icon/png/1710504284_93059095-3c2a-4087-b4ae-163e8149656e.png',
        textAlignment: 'center',
        logo: 'https://d9aff4nz0lkg0.cloudfront.net/mobligo/mobligo_new.f1a0e145b0fcc9ce50bd.png',
        buttonColor: '#6F59EF',
        buttonTextColor: '#FFFFFF',
        accentColor: '#7059ef',
      },
      variantData: {
        isEditable: true,
        aspectRatio: '1/1',
        minImage: 4,
        maxImage: 12,
        modulo: 1,
        renderTabs: {
          product: null,
        },
      },
      placeholderImage: 'https://d9aff4nz0lkg0.cloudfront.net/login_16.png',
      minMobileAppVersion: 1,
      isComingSoon: true,
    },
    {
      id: 'SignIn_17',
      name: 'SignIn_17',
      type: 'SignIn',
      data: {
        text: '',
        description: '',
        privacyPolicyLink: '',
        images: [],
      },
      customization: {
        textColor: '#000000',
        textSize: '20px',
        textWeight: '700',
        passwordOpenIcon:
          'https://d9aff4nz0lkg0.cloudfront.net/icon/png/1710504266_efd51b93-7875-4bc5-aee7-24fecc33b79e.png',
        passwordCloseIcon:
          'https://d9aff4nz0lkg0.cloudfront.net/icon/png/1710504284_93059095-3c2a-4087-b4ae-163e8149656e.png',
        textAlignment: 'left',
        logo: 'https://d9aff4nz0lkg0.cloudfront.net/mobligo/mobligo_new.f1a0e145b0fcc9ce50bd.png',
        buttonColor: '#6F59EF',
        buttonTextColor: '#FFFFFF',
        accentColor: '#7059ef',
      },
      variantData: {
        isEditable: false,
        aspectRatio: '1/1',
        minImage: 4,
        maxImage: 12,
        modulo: 1,
        renderTabs: {
          product: null,
        },
      },
      placeholderImage: 'https://d9aff4nz0lkg0.cloudfront.net/login_17.png',
      minMobileAppVersion: 1,
      isComingSoon: true,
    },
  ],
};

export default SignIn;
